#import "../fragments/stageset-basic.graphql"

query GetStagesetsUnarchived {
    stagesets(includeArchived: false) {
        ...StagesetBasic
    }
}
